import React from 'react';

import {
  LatestArticles,
} from '../../../components';

const ParagraphLatestArticles = ({ id, entity, isForMunicipalities = false }) => {
  return (
    <LatestArticles
      id={id}
      entity={entity}
      isForMunicipalities={isForMunicipalities}
    />
  );
};


export default ParagraphLatestArticles;
